import Vue from 'vue';
import DragDrop from 'vue-drag-and-drop';

Vue.use(DragDrop);


// WEBPACK FOOTER //
// ./src/scripts/drag&drop.js